import React from 'react'

import TudoBenefits from 'assets/svg/tudo_benefits.svg'
import { flexibleBenefits } from '../../data/flexible-benefits'

import Button from 'components/Button'

import { Container, Desc, Title, Header, LinkNoMobile } from './style'

import {
    Subtitle,
    Content,
    Info,
    List,
    BenefitContainer,
    BenefitName,
    Banner
} from './ProductTudoFlexibleBenefits.style'

const ProductTudoFlexibleBenefits = () => {
    return (
        <Container>
            <Header>
                <Title>Cartão com benefícios flexíveis</Title>
                <Desc>
                    Todas as soluções que a sua empresa precisa em um único
                    cartão, com a flexibilidade Alelo
                </Desc>
            </Header>
            <Content>
                <Info>
                    <Subtitle>
                        Para todas as necessidades e todos os tipos e tamanhos
                        de empresas.
                    </Subtitle>
                    <Desc>
                        Com ele, você tem a possibilidade de compor o portfólio
                        de benefícios da sua empresa como precisar, seja para:
                    </Desc>
                    <List>
                        {flexibleBenefits.map((benefits) => (
                            <BenefitContainer
                                className="kkkkk"
                                key={benefits.text}
                            >
                                <img src={benefits.icon} alt={benefits.text} />
                                <BenefitName>{benefits.text}</BenefitName>
                            </BenefitContainer>
                        ))}
                        <BenefitContainer key="more" className="placeholder">
                            <img />
                            <BenefitName>... e muitos mais.</BenefitName>
                        </BenefitContainer>
                    </List>
                    <span className="more">... e muitos mais.</span>
                </Info>
                <Banner>
                    <img src={TudoBenefits} alt="Beneficios do Alelo Tudo" />
                </Banner>
            </Content>
            <LinkNoMobile href="#">
                <Button kind="add">Eu quero</Button>
            </LinkNoMobile>
        </Container>
    )
}

export default ProductTudoFlexibleBenefits
